import { render } from "./SubPage1.vue?vue&type=template&id=98ac6304&scoped=true"
import script from "./SubPage1.vue?vue&type=script&lang=js"
export * from "./SubPage1.vue?vue&type=script&lang=js"

import "./SubPage1.vue?vue&type=style&index=0&id=98ac6304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ac6304"]])

export default __exports__